import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { getStuff } from '../../helpers/firestore';
import MangaManager from './MangaManager';
import { Helmet } from "react-helmet";
import { linksList } from '../../constants/links';



const ManageOtherScreen = () => {

    const mangaTemplate = {
        author: {id:''},
        date: new Date(),
        description: '',
        img: '',
        name: '',
        thumbnail: '',
        links: linksList,
        collabs: [],
        tags: {
            general: {
                list: [],
                order: 0
            },
            series: {
                list: [],
                order: 1
            },
            characters: {
                list: [],
                order: 2
            },
            ships: {
                list: [],
                order: 3
            }
        },
        lewd: false
    }

    // Read from database if on the URL
    const { otherId } = useParams();
    const [manga, setManga] = useState(null)
    const [initialAuthorId, setInitialAuthorId] = useState('');

    useEffect(() => {
        // Load from database database woah woah
        if (otherId) {
            getStuff(otherId, true)
                .then((returnedManga) => {
                    setManga(returnedManga);
                    setInitialAuthorId(returnedManga.author.id);
                })
                .catch((error) => alert(error));
        }
    }, [otherId])

    //console.log(manga)

    return (
        <>
            <Helmet>
                <title>Other Manager</title>
            </Helmet>
            {
                otherId
                    ?
                    manga
                        ?
                        <MangaManager
                            manga={manga}
                            editMode={true}
                            initialAuthorId={initialAuthorId}
                            other={true}
                        />
                        :
                        'loading...'
                    :
                    <MangaManager
                        manga={mangaTemplate}
                        editMode={false}
                        initialAuthorId={initialAuthorId}
                        other={true}
                    />
            }
        </>
    )

}

export default ManageOtherScreen;